module.exports = __webpack_public_path__ + "static/media/xinghai01.3ddbdf70.jpg";